import React from 'react';
import './TrustBadge.css';
import { motion } from 'framer-motion';

const TrustBadge = ({ isEnglish }) => {
    // アニメーション設定
    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut",
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    // アイコン（SVG）
    const CrownIcon = () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px', marginBottom: '2px' }}>
            <path d="M2 20H22M5 16L2 6L9 9L12 2L15 9L22 6L19 16H5Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const MedalIcon = () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px', marginBottom: '2px' }}>
            <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <section className="trust-badge-section">
            <motion.div
                className="trust-badge-container"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={containerVariants}
            >
                {/* Booking.com Badge */}
                <motion.a
                    href="https://www.booking.com/hotel/jp/kanazawa-stay-akebono.ja.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge-card booking-card"
                    variants={itemVariants}
                >
                    {/* 強調されたヘッダー */}
                    <div className="badge-header-wrapper">
                        <div className="badge-header gold-gradient">
                            <CrownIcon />
                            <span className="badge-label-text">AWARD WINNER 2026</span>
                        </div>
                    </div>

                    <div className="badge-body">
                        <h3 className="badge-title">Booking.com</h3>

                        {/* 9.9 スコア */}
                        <div className="score-row">
                            <span className="score-val">9.9</span>
                            <span className="score-max">/10</span>
                        </div>

                        <div className="badge-divider"></div>

                        {/* 賞の名称を強調 */}
                        <p className="badge-award-name">
                            Traveller Review Awards
                        </p>
                    </div>
                </motion.a>

                {/* Airbnb Badge */}
                <motion.a
                    href="https://www.airbnb.jp/rooms/1301957240780340751?source_impression_id=p3_1769702031_P3Z7CJhdSrzI9ZOL"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge-card airbnb-card"
                    variants={itemVariants}
                >
                    {/* 強調されたヘッダー */}
                    <div className="badge-header-wrapper">
                        <div className="badge-header gold-gradient">
                            <MedalIcon />
                            <span className="badge-label-text">SUPERHOST</span>
                        </div>
                    </div>

                    <div className="badge-body">
                        <h3 className="badge-title">Airbnb</h3>

                        {/* 5.0 スコア */}
                        <div className="score-row">
                            <span className="airbnb-star-icon">★</span>
                            <span className="score-val">5.0</span>
                        </div>

                        <div className="badge-divider"></div>

                        <p className="badge-status-highlight">
                            {isEnglish ? 'Top Rated & Reliable' : '最高評価 & 信頼の証'}
                        </p>
                    </div>
                </motion.a>
            </motion.div>

            {/* メッセージ */}
            <motion.p
                className="trust-message"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
            >
                {isEnglish
                    ? "Highly Rated by Guests Worldwide"
                    : "世界中のお客様から高評価をいただいています"}
            </motion.p>
        </section>
    );
};

export default TrustBadge;